import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_107e5l5t3v: FaireBrandEntity = {
  token: "b_107e5l5t3v",
  type: "brand",
  name: "LAPCOS",
  avatarUrl:
    "https://cdn.faire.com/fastly/d9865281083b7efbd1bbad35515080b6d9b22eae477311ff5b357a8b4095b559.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/7e79ce84b35e4d9bd92ac6827e17235a44d7e4587a10e7b526ec665b5368c937.png",
  logoUrl:
    "https://cdn.faire.com/fastly/d9865281083b7efbd1bbad35515080b6d9b22eae477311ff5b357a8b4095b559.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/7e79ce84b35e4d9bd92ac6827e17235a44d7e4587a10e7b526ec665b5368c937.png",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 75,
  rating: 5,
  reviewCount: 113,
  isTopShop: true,
  isInsider: true,
  description:
    "lapcos [re: the los angeles cosmetics project]\n\nRooted in Korean traditions and technologies, inspired by the sunny, breezy and endlessly creative Los Angeles way of life, we curate the perfect blend between tried-and-true formulations and practices that stand the test of time. We’re here to share skincare staples that will suit your lifestyle with the same level of ease that comes with cracking open an ice cold kombucha. \n\n\na tale of two cities. \n\nOur Founder & President, Jen was raised in Los Angeles surrounded by her family’s Korean culture and traditions, passed down through generations. From a young age, Jen learned that careful, consistent skin care is an essential part of healthy, beautiful wellbeing and that you cannot treat one part of the body without considering the whole. \n\nJen’s upbringing reflects the blending of two distinct and vibrant cultures. It has lended her the ability and the inspiration to source the best of Seoul, the skin care capital of the world, and Southern California, as synonymous with effortless coastal beauty as much as it is artistry and wellness.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:43:52.344Z",
    importedBy: "entity-db-cli",
  },
};
